import React from 'react';
import { DOMRefValue } from '@react-types/shared';

const isDOMRef = <T extends HTMLElement>(
  ref: React.RefObject<T> | React.RefObject<DOMRefValue<T>>
): ref is React.RefObject<DOMRefValue<T>> => {
  return (
    (ref as React.RefObject<DOMRefValue<T>>).current?.UNSAFE_getDOMNode !==
    undefined
  );
};

export const unpackRef = <T extends HTMLElement>(
  ref: React.RefObject<T> | React.RefObject<DOMRefValue<T>>
): T | null => {
  if (!ref.current) {
    return null;
  }

  if (isDOMRef(ref)) {
    return ref.current.UNSAFE_getDOMNode();
  }

  return ref.current;
};
